


// src/pages/Tasks/TaskForm.jsx
import React, { useState, useEffect, useRef } from "react";
import api from "../../utils/api";

export default function TaskForm({ open, onClose }) {
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [leadSearch, setLeadSearch] = useState("");
  const [leadResults, setLeadResults] = useState([]);
  const [relatedSearch, setRelatedSearch] = useState("");
const [relatedResults, setRelatedResults] = useState([]);
  const [searching, setSearching] = useState(false);

  // New state for attachments
  const [attachments, setAttachments] = useState([]); // File objects
  const [urls, setUrls] = useState([""]); // Array of URL strings

  const [form, setForm] = useState({
    title: "",
    module: "General",
    related_record_id: "",
    related_record_uid: "",
    related_record_name: "",
    related_record_mobile: "",
    assigned_to: "",
    assigned_team_id: "",
    priority: "Medium",
    start_date: "",
    due_date: "",
    needs_approval: false,
    approver_id: "",
    notes: "",
  });

  const titleInputRef = useRef(null);
  const fileInputRef = useRef(null);

  // Reset related record when module changes
  // useEffect(() => {
  //   if (form.module !== "Lead") {
  //     setForm(prev => ({
  //       ...prev,
  //       related_record_id: "",
  //       related_record_uid: "",
  //       related_record_name: "",
  //       related_record_mobile: "",
  //     }));
  //     setLeadSearch("");
  //     setLeadResults([]);
  //   }
  // }, [form.module]);
useEffect(() => {
  if (!["Lead", "Project"].includes(form.module) || !relatedSearch.trim()) {
    setRelatedResults([]);
    setSearching(false);
    return;
  }

  const query = relatedSearch.trim();
  const delay = 400;

  const timer = setTimeout(async () => {
    setSearching(true);
    try {
      const res = await api.get("/tasks/search-related", {
        params: { q: query, module: form.module }
      });
      setRelatedResults(res.data.records || []);
    } catch (err) {
      console.error("Related search failed:", err);
    } finally {
      setSearching(false);
    }
  }, delay);

  return () => clearTimeout(timer);
}, [relatedSearch, form.module]);


  // // Load users on open
  // useEffect(() => {
  //   if (open) {
  //     api.get("/users")
      
  //       .then(res => {
  //         const allUsers = res.data.users || [];
  //         setUsers(allUsers);
  //         setApprovers(allUsers.filter(u => ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)));
  //       })
  //       .catch(() => alert("Failed to load users"));

  //     setTimeout(() => titleInputRef.current?.focus(), 100);
  //   }
  // }, [open]);
  useEffect(() => {
    if (open) {
      Promise.all([
        api.get("/users"),
        api.get("/teams"),
      ])
        .then(([userRes, teamRes]) => {
          const allUsers = userRes.data.users || [];
          setUsers(allUsers);
          setTeams(teamRes.data.teams || []);

          // Approvers: SuperAdmin, Admin, TeamLead
          setApprovers(allUsers.filter(u =>
            ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)
          ));
        })
        .catch(() => alert("Failed to load users or teams"));

      setTimeout(() => titleInputRef.current?.focus(), 100);
    }
  }, [open]);

  // Lead search logic (unchanged)
  useEffect(() => {
    if (form.module !== "Lead" || !leadSearch.trim()) {
      setLeadResults([]);
      setSearching(false);
      return;
    }

    const query = leadSearch.trim();
    const delay = /^LW-\d{6,}$/.test(query) ? 300 : 600;

    const timer = setTimeout(async () => {
      setSearching(true);
      try {
        const res = await api.get(`/tasks/search-leads?q=${encodeURIComponent(query)}`);
        const leads = res.data.leads || [];
        setLeadResults(leads);

        if (leads.length === 1 && leads[0].lead_uid.toUpperCase() === query.toUpperCase()) {
          const lead = leads[0];
          setForm(prev => ({
            ...prev,
            related_record_id: lead.id,
            related_record_uid: lead.lead_uid,
            related_record_name: lead.name,
            related_record_mobile: lead.mobile || "",
          }));
          setLeadSearch("");
          setLeadResults([]);
        }
      } catch (err) {
        console.error("Lead search failed:", err);
      } finally {
        setSearching(false);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [leadSearch, form.module]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments(prev => [...prev, ...files]);
  };

  const removeFile = (index) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const addUrlField = () => {
    setUrls(prev => [...prev, ""]);
  };

  const updateUrl = (index, value) => {
    setUrls(prev => prev.map((url, i) => i === index ? value : url));
  };

  const removeUrl = (index) => {
    setUrls(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!form.title.trim()) return alert("Task Title is required");
    // if (!form.assigned_to) return alert("Please assign the task");
    if (!form.assigned_to && !form.assigned_team_id) {
      return alert("Please assign the task to a user or a team");
    }
    // if (form.module === "Lead" && !form.related_record_id) return alert("Please select a Lead");
//     if (form.module === "Lead") {
//   formData.append("lead_id", Number(form.related_record_id));
// } else if (form.module === "Project") {
//   formData.append("project_id", Number(form.related_record_id));
// }
    if (form.needs_approval && !form.approver_id) return alert("Please select an approver");

    const departmentMap = {
      Lead: "Sales",
      Project: "Design",
      Invoice: "Accounts",
      Accounts: "Accounts",
      Service: "Production",
      HR: "Management",
    };
    const department = departmentMap[form.module] || "Management";

    const formData = new FormData();

    // Append basic fields
    formData.append("title", form.title.trim());
    formData.append("description", form.notes.trim() || "");
    formData.append("module", form.module);
    // if (form.module === "Lead") {
    //   formData.append("lead_id", Number(form.related_record_id));
    // }
    // In TaskForm.jsx handleSubmit, modify the formData append for related records:

// if (form.module === "Lead") {
//   formData.append("lead_id", Number(form.related_record_id));
// } else if (form.module === "Project") {
//   formData.append("project_id", Number(form.related_record_id));
// }
if (form.module === "Lead") {
  formData.append("lead_id", Number(form.related_record_id));
} else if (form.module === "Project") {
  formData.append("project_id", Number(form.related_record_id));
}
    formData.append("department", department);
    // formData.append("assigned_to", Number(form.assigned_to));

    if (form.assigned_to) {
      formData.append("assigned_to", Number(form.assigned_to));
    }
    if (form.assigned_team_id) {
      formData.append("assigned_team_id", Number(form.assigned_team_id));
    }
    formData.append("priority", form.priority);
    if (form.start_date) formData.append("start_date", form.start_date);
    if (form.due_date) formData.append("due_date", form.due_date);
    formData.append("requires_approval", form.needs_approval);
    if (form.needs_approval) {
      formData.append("approver_id", Number(form.approver_id));
    }

    // Append files
    attachments.forEach((file) => {
      formData.append("attachments", file);
    });

    // Append URLs (only non-empty)
    const validUrls = urls.filter(url => url.trim());
    validUrls.forEach((url, i) => {
      formData.append("urls", url.trim());
    });

    try {
      await api.post("/tasks", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      onClose(true);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Failed to create task");
    }
  };

  // const clearLead = () => {
  //   setForm(prev => ({
  //     ...prev,
  //     related_record_id: "",
  //     related_record_uid: "",
  //     related_record_name: "",
  //     related_record_mobile: "",
  //   }));
  //   setLeadSearch("");
  // };
  const clearRelated = () => {
  setForm(prev => ({
    ...prev,
    related_record_id: "",
    related_record_uid: "",
    related_record_name: "",
    related_record_mobile: "",
  }));
  setRelatedSearch("");
  setRelatedResults([]);
};

  if (!open) return null;

  const selectedLeadDisplay = form.related_record_id
    ? `${form.related_record_uid} — ${form.related_record_name}${form.related_record_mobile ? ` (${form.related_record_mobile})` : ""}`
    : "— No lead selected —";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Create New Task</h2>
          <button
            onClick={() => onClose(false)}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          {/* Title */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Task Title <span className="text-red-500">*</span>
            </label>
            <input
              ref={titleInputRef}
              type="text"
              value={form.title}
              onChange={e => setForm({ ...form, title: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
              placeholder="Enter task title"
            />
          </div>

          {/* Module */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Department</label>
            <select
              value={form.module}
              onChange={e => setForm({ ...form, module: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
            >
              <option>General</option>
              <option>Lead</option>
              <option>Project</option>
              <option>Invoice</option>
              <option>Service</option>
              <option>HR</option>
              <option>Accounts</option>
            </select>
          </div>

          {/* Lead Search */}
         

{form.module === "Lead" || form.module === "Project" ? (
  <div>
    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
      Related {form.module} <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      value={relatedSearch}
      onChange={(e) => setRelatedSearch(e.target.value)}
      placeholder={`Search by ${form.module === "Lead" ? "LW-" : "PROJ-"}XXXXXX, name...`}
      className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
    />

    <div className={`p-4 rounded-lg border ${form.related_record_id ? "bg-blue-50 dark:bg-blue-900/20 border-blue-300" : "bg-gray-50 dark:bg-gray-700 border-gray-300"}`}>
      <div className="flex justify-between items-center">
        <span className="font-medium text-gray-900 dark:text-white">
          {form.related_record_id
            ? `${form.related_record_uid || form.project_uid || "—"} — ${form.related_record_name || "—"}`
            : "— No record selected —"}
        </span>
        {form.related_record_id && (
          <button onClick={clearRelated} className="text-red-600 hover:underline text-sm">
            Clear
          </button>
        )}
      </div>
    </div>

    {relatedResults.length > 0 && (
      <div className="mt-3 max-h-64 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 shadow-lg">
        {relatedResults.map(record => (
          <div
            key={record.id}
            onClick={() => {
              setForm(prev => ({
                ...prev,
                related_record_id: record.id,
                related_record_uid: record.lead_uid || record.project_uid,
                related_record_name: record.name,
                // Optional: store mobile only for leads
                ...(form.module === "Lead" && { related_record_mobile: record.mobile || "" }),
              }));
              setRelatedSearch("");
              setRelatedResults([]);
            }}
            className="p-4 hover:bg-blue-50 dark:hover:bg-blue-900/30 cursor-pointer border-b border-gray-200 dark:border-gray-700 last:border-0"
          >
            <div className="font-medium">
              {record.lead_uid || record.project_uid} — {record.name}
            </div>
            {form.module === "Lead" && record.mobile && (
              <div className="text-sm text-gray-600 dark:text-gray-400">
                Mobile: {record.mobile}
              </div>
            )}
          </div>
        ))}
      </div>
    )}

    {searching && <div className="mt-3 text-center text-gray-500">Searching...</div>}
  </div>
) : null}
          {/* {form.module === "Lead" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Related Lead <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={leadSearch}
                onChange={e => setLeadSearch(e.target.value)}
                placeholder="Search by Lead ID (LW-XXXXXX), name, or mobile..."
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
              />
              <div className={`p-4 rounded-lg border ${form.related_record_id ? "bg-blue-50 dark:bg-blue-900/20 border-blue-300" : "bg-gray-50 dark:bg-gray-700 border-gray-300"}`}>
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-900 dark:text-white">
                    {form.related_record_id ? selectedLeadDisplay : "— No lead selected —"}
                  </span>
                  {form.related_record_id && (
                    <button onClick={clearLead} className="text-red-600 hover:underline text-sm">
                      Clear
                    </button>
                  )}
                </div>
              </div>
              {leadResults.length > 0 && (
                <div className="mt-3 max-h-64 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 shadow-lg">
                  {leadResults.map(lead => (
                    <div
                      key={lead.id}
                      onClick={() => {
                        setForm(prev => ({
                          ...prev,
                          related_record_id: lead.id,
                          related_record_uid: lead.lead_uid,
                          related_record_name: lead.name,
                          related_record_mobile: lead.mobile || "",
                        }));
                        setLeadSearch("");
                        setLeadResults([]);
                      }}
                      className="p-4 hover:bg-blue-50 dark:hover:bg-blue-900/30 cursor-pointer border-b border-gray-200 dark:border-gray-700 last:border-0"
                    >
                      <div className="font-medium">{lead.lead_uid} — {lead.name}</div>
                      <div className="text-sm text-gray-600 dark:text-gray-400">
                        Mobile: {lead.mobile || "—"}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {searching && <div className="mt-3 text-center text-gray-500">Searching...</div>}
            </div>
          )} */}
{/* Assignment: User OR Team */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Assign to User */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Assign to User
              </label>
              <select
                value={form.assigned_to}
                onChange={e => setForm({ 
                  ...form, 
                  assigned_to: e.target.value,
                  assigned_team_id: e.target.value ? "" : form.assigned_team_id // clear team if user selected
                })}
                disabled={!!form.assigned_team_id}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 disabled:opacity-50"
              >
                <option value="">None</option>
                {users.map(u => (
                  <option key={u.id} value={u.id}>
                    {u.name} ({u.role})
                  </option>
                ))}
              </select>
            </div>

            {/* OR Assign to Team */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Assign to Team
              </label>
              <select
                value={form.assigned_team_id}
                onChange={e => setForm({ 
                  ...form, 
                  assigned_team_id: e.target.value,
                  assigned_to: e.target.value ? "" : form.assigned_to // clear user if team selected
                })}
                disabled={!!form.assigned_to}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 disabled:opacity-50"
              >
                <option value="">None</option>
                {teams.map(team => (
                  <option key={team.id} value={team.id}>
                    {team.name} ({team.memberCount} members)
                  </option>
                ))}
              </select>
              <p className="text-xs text-gray-500 mt-2">
                All team members will see and can complete this task
              </p>
            </div>
          </div>
          {/* Assigned To */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Assigned To <span className="text-red-500">*</span>
            </label>
            <select
              value={form.assigned_to}
              onChange={e => setForm({ ...form, assigned_to: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
            >
              <option value="">Select user</option>
              {users.map(u => (
                <option key={u.id} value={u.id}>
                  {u.name} ({u.role}) — {u.id}
                </option>
              ))}
            </select>
          </div> */}

          {/* Priority */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Priority</label>
            <select
              value={form.priority}
              onChange={e => setForm({ ...form, priority: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
            >
              <option>Cold</option>
              <option>Warm</option>
              <option>Hot</option>
            </select>
          </div>

          {/* Dates */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Start Date</label>
              <input
                type="date"
                value={form.start_date}
                onChange={e => setForm({ ...form, start_date: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Due Date</label>
              <input
                type="date"
                value={form.due_date}
                onChange={e => setForm({ ...form, due_date: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
              />
            </div>
          </div>

          {/* Approval */}
          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={form.needs_approval}
                onChange={e => setForm({ ...form, needs_approval: e.target.checked })}
                className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Needs Approval?
              </span>
            </label>

            {form.needs_approval && (
              <div className="mt-5">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Select Approver <span className="text-red-500">*</span>
                </label>
                <select
                  value={form.approver_id}
                  onChange={e => setForm({ ...form, approver_id: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
                >
                  <option value="">Choose approver</option>
                  {approvers.map(u => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.role})
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* === NEW: File Attachments === */}
          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Attach Files (optional)
            </label>
            <input
              ref={fileInputRef}
              type="file"
              multiple
              onChange={handleFileChange}
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
            <p className="text-xs text-gray-500 mt-1">Max 10 files</p>

            {attachments.length > 0 && (
              <div className="mt-3 space-y-2">
                {attachments.map((file, index) => (
                  <div key={index} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    <span className="text-sm truncate">{file.name}</span>
                    <button
                      onClick={() => removeFile(index)}
                      className="text-red-600 hover:text-red-800 text-sm"
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* === NEW: URL Links === */}
          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Add Links / URLs (optional)
              </label>
              <button
                onClick={addUrlField}
                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                + Add URL
              </button>
            </div>

            {urls.map((url, index) => (
              <div key={index} className="flex gap-3 mb-3">
                <input
                  type="url"
                  value={url}
                  onChange={(e) => updateUrl(index, e.target.value)}
                  placeholder="https://example.com/document"
                  className="flex-1 px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
                />
                <button
                  onClick={() => removeUrl(index)}
                  className="px-4 py-3 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          {/* Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Notes / Description</label>
            <textarea
              rows={4}
              value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
              placeholder="Add any additional instructions or context..."
              className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 resize-none"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
          <button
            onClick={() => onClose(false)}
            className="px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-8 py-3 bg-slate-800 hover:bg-slate-800 text-white rounded-lg font-medium shadow transition"
          >
            Create Task
          </button>
        </div>
      </div>
    </div>
  );
}